<template>
  <div
    class="grow-0 transition-[height] duration-500"
    :class="
      openMenu && menuDirection === 'vertical' ? 'h-0 overflow-y-hidden' : 'h-'
    "
  >
    <div
      class="bg-white relative flex flex-col pt-[15px] w-full max-md:max-w-full panel-main-header"
    >
      <div
        class="flex items-stretch justify-between gap-5 mx-4 md:mx-9 max-md:max-w-full max-md:flex-wrap mr-4 max-md:mr-2.5"
      >
        <div
          class="flex h-[42px] items-center justify-between gap-5 w-full md:w-fit"
        >
          <button
            @click="toggleSidebar()"
            class="cursor-pointer xl2:hidden menu-container"
          >
            <!-- <img src="@/assets/icons/svg/menu.svg" /> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="42"
              height="42"
              viewBox="0 0 46 46"
              fill="none"
            >
              <rect
                x="0.5"
                y="0.5"
                width="45"
                height="45"
                rx="22.5"
                stroke="#E5E5E5"
              />
              <path
                d="M32 18.75H14C13.59 18.75 13.25 18.41 13.25 18C13.25 17.59 13.59 17.25 14 17.25H32C32.41 17.25 32.75 17.59 32.75 18C32.75 18.41 32.41 18.75 32 18.75Z"
                fill="black"
              />
              <path
                d="M32 23.75H14C13.59 23.75 13.25 23.41 13.25 23C13.25 22.59 13.59 22.25 14 22.25H32C32.41 22.25 32.75 22.59 32.75 23C32.75 23.41 32.41 23.75 32 23.75Z"
                fill="black"
              />
              <path
                d="M32 28.75H14C13.59 28.75 13.25 28.41 13.25 28C13.25 27.59 13.59 27.25 14 27.25H32C32.41 27.25 32.75 27.59 32.75 28C32.75 28.41 32.41 28.75 32 28.75Z"
                fill="black"
              />
            </svg>
          </button>
          <div class="max-xl2:hidden h-full flex items-center justify-center">
            <div
            @click="logout"
              class="flex border h-[42px] w-[42px] rounded-full items-center justify-center"
            >
              <p
                class="text-qooBlack-7 text-[18px] md:text-[20px] font-medium flex gap-2 cursor-pointer items-center justify-start"
                
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M16.8 2H14.2C11 2 9 4 9 7.2V11.25H15.25C15.66 11.25 16 11.59 16 12C16 12.41 15.66 12.75 15.25 12.75H9V16.8C9 20 11 22 14.2 22H16.79C19.99 22 21.99 20 21.99 16.8V7.2C22 4 20 2 16.8 2Z"
                    fill="#E5E5E5"
                  />
                  <path
                    d="M4.55994 11.2498L6.62994 9.17984C6.77994 9.02984 6.84994 8.83984 6.84994 8.64984C6.84994 8.45984 6.77994 8.25984 6.62994 8.11984C6.33994 7.82984 5.85994 7.82984 5.56994 8.11984L2.21994 11.4698C1.92994 11.7598 1.92994 12.2398 2.21994 12.5298L5.56994 15.8798C5.85994 16.1698 6.33994 16.1698 6.62994 15.8798C6.91994 15.5898 6.91994 15.1098 6.62994 14.8198L4.55994 12.7498H8.99994V11.2498H4.55994Z"
                    fill="#E5E5E5"
                  />
                </svg>
              </p>
            </div>
          </div>
          <a href="/" class="flex items-center">
            <img
              src="@/assets/images/header/logo-horizontal.svg"
              loading="lazy"
              class="aspect-[2.13] object-contain max-h-[42px] object-center w-[102px] overflow-hidden self-center shrink-0 max-w-full my-auto"
            />
          </a>
          <span class="admin-text text-danger-1000 font-[700] text-[16px]" v-if="loadingStore.isDeveloper">
            ADMIN VIEW
          </span>
        </div>
        <div class="main-header-nav absolute !w-fit top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-xl2:hidden flex justify-center">
          <nav
            class="nav-pill flex bg-[#f5f5f5] items-center rounded-full gap-0"
          >
            <template v-for="(item, index) in navItems" :key="item.label">
              <router-link
                :exact-active-class="getActiveClass(item.label)"
                :class="[
                  'px-6 py-2 rounded-xl  text-sm font-medium transition',
                ]"
                :to="item.route"
              >
                {{ item.label }}
              </router-link>
              <div
                v-if="index < navItems.length - 1"
                class="h-[60%] w-[1px] bg-[#ebebeb]"
              ></div>
            </template>
          </nav>
        </div>
        <div
          class="hidden h-[42px] md:flex items-center justify-between gap-3 max-md:max-w-full max-md:flex-wrap"
        >
          <EnhancedButton
            type="primary"
            icon="star2.svg"
            text="Favourites"
            class-list="h-[42px]"
            padding-style="px-[25.25px] py-[10.37px]"
            width="w-5"
            @clickBtn="favouritesPage"
          ></EnhancedButton>
          <VDropdown :triggers="['click']" placement="bottom" :distance="16">
            <EnhancedButton
              v-if="+showWorksheetRoute"
              icon="worksheet.svg"
              class-list="h-[42px]"
              padding-style="px-[25.25px] py-[10.37px]"
              text="Submit Worksheet"
              hoverEffect="none"
              :hasCounter="true"
              @clickBtn="worksheet"
              :counterNumber="store.worksheetId?.length"
            ></EnhancedButton>
            <!-- @clickBtn="worksheet" -->
            <template #popper="{ hide }">
              <div class="dropdown-container p-4">
                <div
                  class="dropdown bg-white rounded-lg p-6 w-[426px] min-h-[200px]"
                >
                  <popupWorksheet
                    :models="data"
                    :hide="hide"
                    :counterNumber="store.worksheetId"
                    @submitWorksheet="worksheet(hide)"
                  >
                  </popupWorksheet>
                </div>
              </div>
            </template>
          </VDropdown>
        </div>
      </div>
      <div
        class="qoo-line min-h-[1px] w-full mt-[14px] max-md:max-w-full"
        :class="openMenu ? '' : 'bg-menu-color'"
      ></div>
    </div>
    <MainMenuHorizontal
      v-if="menuDirection === 'horizontal'"
      class="transition-transform duration-500"
      :class="openMenu ? 'translate-y-0' : '-translate-y-[140vh]'"
      @closeSidebar="closeSidebar"
    />
    <MainMenuVertical
      v-else-if="menuDirection === 'vertical'"
      :openMenu="openMenu"
      @closeSidebar="closeSidebar"
    />
  </div>
</template>

<script setup>
import { ref, watchEffect, onMounted, watch, computed } from "vue";
import MainMenuHorizontal from "./MainMenuHorizontal.vue";
import MainMenuVertical from "./MainMenuVertical.vue";
import EnhancedButton from "./common/EnhancedButton.vue";
import { useRouter, useRoute } from "vue-router";
import { useWorksheets } from "@/store/worksheet.js";
import { useVerticalMenu } from "@/store/verticalMenu";
import { useStore } from "@/store/loading.js";
import popupWorksheet from "./PopupWorksheet.vue";
import { useQuery } from "@tanstack/vue-query";
import { floorsQuery } from "@/services/axios/floors.service.js";
import { useCookies } from "vue3-cookies";

const menuDirection = process.env.VUE_APP_MENU_DIRECTION;
const showWorksheetRoute = process.env.VUE_APP_SHOW_WORKSHEET;

const router = useRouter();
const { cookies } = useCookies();
const route = useRoute();
const openMenu = ref(false);
const store = ref({});
store.value = useWorksheets();
const loadingStore = ref({});
loadingStore.value = useStore();
const orders = ref([]);
let apiFrameEl = null;
const data = ref([]);

const toggleSidebar = () => {
  openMenu.value = !openMenu.value;

  // if (openMenu.value) {
  //   document.getElementsByTagName("html")[0].style.overflow = "hidden";
  // } else {
  //   document.getElementsByTagName("html")[0].style.overflow = "auto";
  // }
};

function getActiveClass(label) {
  if (route.query.compare === "true") {
    return;
  }
  if (route.query.full_3d) {
    if (route.query.full_3d === "true" && label === "Building") {
      return "active-route";
    } else if (route.query.full_3d === "false" && label === "Floorplans") {
      return "active-route";
    }
  } else if (route.query.model && label === "Building") {
    return "";
  } else {
    return "active-route";
  }
}

const navItems = [
  {
    label: "Building",
    route: { name: "floorplans", query: { full_3d: true } },
  },
  {
    label: "Floorplans",
    route: { name: "floorplans", query: { full_3d: false } },
  },
  {
    label: "Neighbourhood",
    route: { name: "neighbourhood" },
  },
  {
    label: "Gallery",
    route: { name: "gallery" },
  },
  {
    label: "Team",
    route: { name: "builderstory-page" },
  },
  {
    label: "Broker Package",
    route: { name: "broker-package-page" },
  },
  {
    label: "Book an appointment",
    route: { name: "contact-us" },
  },
  // {
  //   label: "Feature and Finishes",
  //   route: { name: "feature-and-finishes" },
  // },
];

const logout = () => {
  cookies.remove("token");
  localStorage.removeItem("user");
  setTimeout(() => {
    location.reload();
  }, 2000);
};

const { data: modelsQuery, isLoading: getModelsLoading } = useQuery({
  queryKey: ["models"],
  queryFn: floorsQuery,
  select: (data) => data.data,
  enabled: true,
});

watchEffect(() => {
  if (modelsQuery.value) {
    setTimeout(async () => {
      let res;
      data.value = [];
      res = modelsQuery.value;
      const compare = (a, b) => {
        return a.area - b.area;
      };
      res.data.sort(compare);
      data.value = res.data;
      if (store.value) {
        store.value.cleanInvalidWorksheets(data.value);
      }
    }, 200);
  }
});

const closeSidebar = () => {
  openMenu.value = false;
};

const favouritesPage = () => {
  if (openMenu.value) {
    toggleSidebar();
  }
  router.push({ name: "favouritesPage" });
};

const worksheet = (hide) => {
  hide();
  if (openMenu.value) {
    toggleSidebar();
  }
  router.push({ name: "worksheet" });
};

onMounted(() => {
  apiFrameEl = document.getElementById("api-frame");
  store.value = useWorksheets();
  if (data.value.length) {
    store.value.cleanInvalidWorksheets(data.value);
  }
});

const verticalMenuStore = useVerticalMenu();

watch(
  () => openMenu.value,
  () => {
    if (menuDirection === "vertical") {
      verticalMenuStore.setIsOpen(openMenu.value);
    }
    if (apiFrameEl && apiFrameEl.style) {
      if (menuDirection === "vertical" && openMenu.value) {
        apiFrameEl.style.height = "calc(100vh - 0rem)";
      } else {
        apiFrameEl.style.height = "calc(100vh - 72px)";
      }
    }
  },
);
</script>

<style lang="scss">
@import "MainHeader.scss";

.qoo-line {
  transition: 1.2s ease all;
}

$menu-width: 24px;
$menu-height: 24px;

.menu-container {
  border-radius: 30px;
  // border: 1px solid #000;
  background: rgba(217, 217, 217, 0);
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;

  & .menu {
    width: $menu-width;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;

    & .menu-item {
      transition: 0.5s ease all;
      display: block;
      width: $menu-width;
      height: 2.5px;
      box-sizing: border-box;
      border-radius: 5px;
      background: #000000;
    }

    &.open {
      .menu-item {
        // background: #000000;
        width: 26px;

        &:first-child {
          transform: rotate(45deg);
          transform-origin: 6px 5px;
        }

        &:nth-child(2) {
          opacity: 0;
        }

        &:nth-child(3) {
          transform: rotate(-45deg);
          transform-origin: 5px -2px;
        }
      }
    }
  }
}

.bg-menu-color {
  background-color: #b3b3b3;
  opacity: 1;
}
</style>
<style lang="scss" scoped>
.dropdown {
  box-shadow: 0px 2px 4px 0px #0000001a;
}
.main-header-nav {
  .nav-pill {
    border-radius: 16px;
    padding: 3px 4px;
    a {
      border: none;
      outline: none;
      background: transparent;
      cursor: pointer;
      &.active-route {
        background: #fff;
        color: #2460E6;
        box-shadow: -2px 2px 10px rgba(0, 0, 0, 0.15);
      }
      &:not(.active-route) {
        color: #878787;
      }
    }
  }
}
</style>
